import React from 'react'
import { Button } from '../../../components/ui/button'
import { Combobox } from '../../../components/ui/combobox'
import { Label } from '../../../components/ui/label'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table'
import { useMutation, useQuery } from '@tanstack/react-query'
import axios from '../../../lib/axios'
import { isAxiosError } from 'axios'
import toast from 'react-hot-toast'
import * as Icon from 'lucide-react'

const PronosPage = () => {
  const [partner_id, setpartner_id] = React.useState<string | undefined>(undefined);
  const [department_id, setdepartment_id] = React.useState<string | undefined>(undefined);
  const [event_id, setevent_id] = React.useState<string | undefined>(undefined);
  const [prono_id, setprono_id] = React.useState<string | undefined>(undefined);

  const { data:partners } = useQuery({
    queryKey: ['partners'],
    queryFn: async () => {
      const {data} = await axios.get<Partner[]>('partners')
      return data
    }
  })

  const { data:departments } = useQuery({
    queryKey: [`departments`, partner_id],
    queryFn: async () => {
      const {data} = await axios.get<PartnerDepartment[]>(`partners/${partner_id}/departments`)
      return data
    },
    enabled: !!partner_id
  })

  const { data:events } = useQuery({
    queryKey: [`events`, partner_id],
    queryFn: async () => {
      const {data} = await axios.get<PartnerEvent[]>(`partners/${partner_id}/events`)
      return data
    },
    enabled: !!partner_id
  })

  const { data:pronos } = useQuery({
    queryKey: [`pronos`, partner_id, event_id],
    queryFn: async () => {
      const {data} = await axios.get<Prono[]>(`pronos?eventid=${event_id}`)
      return data
    },
    enabled: !!partner_id && !!event_id
  })

  const createParticipantLinkMutation = useMutation({
    mutationFn: async () => {
      const { data:link } = await axios.get<string>('participants-link', {
        params: {
          partnerid: partner_id,
          departmentid: department_id,
          eventid: event_id,
          pronoid: prono_id,
          file: 'pdf', // xls - pdf
          list: 'ranking' // ranking - users
        }
      }) 
      return link
    },
    onSuccess: (result) => {
      console.log(result)
      window.open(result, '_blank')
    },
    onError: (error) => {
      if (isAxiosError(error)) {
        const responseData = error.response?.data;
        let message = 'An error occurred';

        if (typeof responseData === 'string') {
            message = responseData; // raw string error message
        } else if (typeof responseData === 'object' && responseData !== null) {
            message = responseData.message || JSON.stringify(responseData);
        }

        toast.error(message, { duration:5000});
      }
      else if (error instanceof Error) {
        toast.error(error.message)
      } else {
        toast.error('Er is een onbekende fout opgetreden.')
      }
    },
  })

  const partnerOptions = partners?.map(p => ({ value: p.m_iPartnerID, label: p.m_sName })) || []
  const departmentOptions = departments?.map(d => ({ value: d.m_iDepartmentID, label: d.m_sName })) || []
  const eventOptions = events?.map(e => ({ value: e.m_iEventID, label: e.m_oEvent.m_sNameNL })) || []
  const pronoOptions = pronos?.map(p => ({ value: p.m_iPronoID, label: p.m_sDescriptionNL })) || []

  return (
    <div className='h-full py-4 text-white bg-tifo'>
      <div className='flex flex-col justify-between h-full gap-4'>
        <div className='grid gap-4 p-4 border md:grid-cols-2 bg-white/10 border-white/20'>
          <div>
              <Label>Partner</Label>
              <Combobox 
                options={partnerOptions} 
                selectedValue={partner_id} 
                onValueChange={(value) => {
                  setpartner_id(value.value.toString())
                  setdepartment_id(undefined)
                  setevent_id(undefined)
                  setprono_id(undefined)
                }}
              />
          </div>
          <div>
              <Label>Department</Label>
              <Combobox 
                disabled={!partner_id}
                options={departmentOptions} 
                selectedValue={department_id} 
                onValueChange={(value) => {
                  setdepartment_id(value.value.toString())
                }}
              />
          </div>
          <div>
              <Label>Event</Label>
              <Combobox 
                disabled={!partner_id}
                options={eventOptions} 
                selectedValue={event_id} 
                onValueChange={(value) => {
                  setevent_id(value.value.toString())
                  setprono_id(undefined)
                }}
              />
          </div>
          <div>
              <Label>Prono</Label>
              <Combobox 
                disabled={!partner_id || !event_id}
                options={pronoOptions} 
                selectedValue={prono_id} 
                onValueChange={(value) => setprono_id(value.value.toString())}
              />
          </div>
          <Button
            onClick={() => createParticipantLinkMutation.mutate()}
            disabled={createParticipantLinkMutation.isPending || !event_id}
            variant='tifo'
          >
            {createParticipantLinkMutation.isPending && <Icon.Loader className='w-4 h-4 animate-spin' />}
            Zoeken
          </Button>
        </div>
      
        <div className='h-full overflow-auto border bg-white/10 border-white/20'>
          
        </div>
      </div>
    </div>
  )
}

export default PronosPage